export default __webpack_public_path__ + "logo.745b078d7f5eb7b11c5cf0405f42ca08.png";